import { Link, useLocation } from 'react-router';
import type { MultiLang } from '../../config';
import mlangEnglish from '../assets/images/mlang_english.gif';
import mlangJapanese from '../assets/images/mlang_japanese.gif';

interface Props {
    lang: MultiLang;
}

const styleLink = {
    fontSize: '8px',
};
const styleImage = {
    verticalAlign: 'middle',
    border: '1px solid #000',
};
const langResources = {
    en: { image: mlangEnglish, title: 'English' },
    ja: { image: mlangJapanese, title: 'Japanese' },
};

const LangFlag = (props: Props) => {
    const { lang } = props;
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const flagLang = lang === 'en' ? 'ja' : 'en';
    params.set('ml_lang', flagLang);
    const url = `${location.pathname}?${params.toString()}`;
    return (
        <Link style={styleLink} to={url}>
            <img
                style={styleImage}
                src={langResources[flagLang].image}
                alt={langResources[flagLang].title}
                title={langResources[flagLang].title}
            />
        </Link>
    );
};

export default LangFlag;
